import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className='bg-gray-100'>
            <div className="max-w-5xl mx-auto px-4 py-10 bg-gray-100">
                <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
                <p className="text-sm text-gray-500 mb-8">Last updated: November 22, 2024</p>

                <section className="space-y-4">
                    <p>
                        This Privacy Policy describes Our policies and procedures on the collection, use and disclosure
                        of Your information when You use the Service and tells You about Your privacy rights and how the law
                        protects You.
                    </p>
                    <p>
                        We use Your Personal data to provide and improve the Service. By using the Service, You agree to the
                        collection and use of information in accordance with this Privacy Policy. This Privacy Policy has
                        been created with the help of the Privacy Policy Generator.
                    </p>

                    <h2 className="text-2xl font-semibold mt-8">Interpretation and Definitions</h2>
                    <h3 className="text-xl font-semibold mt-4">Interpretation</h3>
                    <p>
                        The words of which the initial letter is capitalized have meanings defined under the following
                        conditions. The following definitions shall have the same meaning regardless of whether they appear
                        in singular or in plural.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Definitions</h3>
                    <p>For the purposes of this Privacy Policy:</p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li><strong>Account</strong> means a unique account created for You to access our Service.</li>
                        <li><strong>Affiliate</strong> means an entity that controls, is controlled by, or is under common control with a party.</li>
                        <li><strong>Application</strong> refers to UrbanCab partner.</li>
                        <li><strong>Company</strong> refers to UrbanCab partner.</li>
                        <li><strong>Country</strong> refers to: Rajasthan, India.</li>
                        <li><strong>Device</strong> means any device that can access the Service such as a computer or phone.</li>
                        <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
                        <li><strong>Service</strong> refers to the Application.</li>
                        <li><strong>Service Provider</strong> means any third party processing data on behalf of the Company.</li>
                        <li><strong>Usage Data</strong> refers to data collected automatically through use of the Service.</li>
                        <li><strong>You</strong> means the individual or legal entity using the Service.</li>
                    </ul>

                    <h2 className="text-2xl font-semibold mt-8">Collecting and Using Your Personal Data</h2>
                    <h3 className="text-xl font-semibold mt-4">Types of Data Collected</h3>

                    <h4 className="text-lg font-medium mt-2">Personal Data</h4>
                    <p>We may collect personally identifiable information including:</p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>Email address</li>
                        <li>First and last name</li>
                        <li>Phone number</li>
                        <li>Address, State, ZIP/Postal code, City</li>
                        <li>Usage Data</li>
                    </ul>

                    <h4 className="text-lg font-medium mt-2">Usage Data</h4>
                    <p>Usage Data is collected automatically when using the Service and may include:</p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>IP address, browser type/version, pages visited, time/date of visit</li>
                        <li>Device info (mobile, operating system, identifiers, etc.)</li>
                    </ul>

                    <h4 className="text-lg font-medium mt-2">Location Data</h4>
                    <p>
                        With permission, we may collect location data to enable features. This may be stored on your device or uploaded to our servers.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Use of Your Personal Data</h3>
                    <p>The Company may use Your Personal Data for the following purposes:</p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>To provide and maintain the Service</li>
                        <li>To manage Your Account</li>
                        <li>To perform contracts</li>
                        <li>To contact You</li>
                        <li>To provide marketing and promotional info (unless opted out)</li>
                        <li>To manage Your requests</li>
                        <li>For business transfers or analytics</li>
                    </ul>

                    <h3 className="text-xl font-semibold mt-4">Sharing of Your Personal Data</h3>
                    <p>We may share data with:</p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>Service Providers</li>
                        <li>Business transfers</li>
                        <li>Affiliates</li>
                        <li>Business partners</li>
                        <li>With other users (in public areas)</li>
                        <li>With your consent</li>
                    </ul>

                    <h3 className="text-xl font-semibold mt-4">Retention of Your Personal Data</h3>
                    <p>
                        We will retain Your Personal Data only as long as necessary for the purposes stated. We also retain Usage Data for internal analysis.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Transfer of Your Personal Data</h3>
                    <p>
                        Your data may be processed outside of your jurisdiction. We ensure security measures are in place before transfer.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Delete Your Personal Data</h3>
                    <p>
                        You can delete or request deletion of your data via your account or by contacting us.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Disclosure of Your Personal Data</h3>
                    <p>We may disclose Personal Data under the following:</p>
                    <ul className="list-disc pl-6 space-y-1">
                        <li>Business transactions</li>
                        <li>Legal requirements</li>
                        <li>Protecting rights or safety</li>
                    </ul>

                    <h3 className="text-xl font-semibold mt-4">Security of Your Personal Data</h3>
                    <p>
                        We strive to protect Your Personal Data, but no method is 100% secure. We use reasonable measures to safeguard it.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Children's Privacy</h3>
                    <p>
                        We do not knowingly collect data from children under 13. Contact us if you believe we have done so.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Links to Other Websites</h3>
                    <p>
                        We are not responsible for the privacy practices of third-party sites linked from our Service.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Changes to this Privacy Policy</h3>
                    <p>
                        We may update this Privacy Policy. Changes will be posted here with the updated date. We may also notify You via email or in-app.
                    </p>

                    <h3 className="text-xl font-semibold mt-4">Contact Us</h3>
                    <div>
                        <p className='text-[18px] font-medium text-gray-500 mb-2'>If you have any questions, contact us:</p>
                        <p className=''> <span className=" font-semibold">Legal Name :</span> DIVIRAJ TAXI AND RENTALS PRIVATE LIMITED</p>
        <p className=''> <span className=" font-semibold">Registered Business Address :</span> 675-B, S.NATHPURAM, KOTA, Kota, Rajasthan, 324010</p>
                        Email: <a href="mailto:urbancabpartner@gmail.com" className="text-blue-600 underline">urbancabpartner@gmail.com</a>
                        <br /> Phone: <a href="tel:+919783966966
 " className="text-blue-600 underline">9783966966
 </a>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
